import { i18n } from '@/plugins/i18n';
import { getProblemTrustIndex } from '@/utils/problem-utils';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';


/** Score based on how well described the problems are */
export default new VitalityCriterion({
  titleTr: 'VH_PB_TRUST',
  key: 'problemTrust',
  weight: 2,
  score: ({ problems }, range) => {
    const pPbs = problems.filter(p => range.start.isBefore(p.created) && range.end.isAfter(p.created));
    const score = pPbs.length === 0
      ? 0
      : pPbs.reduce((score, problem) => score + getProblemTrustIndex(problem), 0) / pPbs.length;
    return { score, data: { noTopsFlops: pPbs.length === 0, value: score } };
  },
  text: ({ value }) => i18n.t('message.VH_PB_TRUST_TEXT', { val: value.sToFixed(1) }),
});
